import { markdownToExcerpt } from './content.js';

function guessTitleFromMarkdown(md) {
  const m = md.match(/^#\s+(.+)$/m);
  return m ? m[1].trim() : '';
}

export async function importFile(file, { editor, pendingImages, onStatus, onImported }) {
  const ext = (file.name.split('.').pop() || '').toLowerCase();
  onStatus(`Importando ${file.name}…`);
  try {
    let markdown = '';
    let images = [];
    if (ext === 'docx') {
      const { convertDocx } = await import('./converters/docx.js');
      const r = await convertDocx(file);
      markdown = r.markdown;
      images = r.images;
    } else if (ext === 'pdf') {
      const { convertPdf } = await import('./converters/pdf.js');
      const r = await convertPdf(file);
      if (r.empty) throw new Error('El PDF no contiene texto extraíble (probablemente es escaneado). No se pudo importar.');
      markdown = r.markdown;
    } else {
      markdown = await file.text();
    }

    if (!markdown.trim()) {
      onStatus('El archivo no contiene texto.', 'warn');
      return;
    }

    if (images.length) {
      pendingImages.pushItems(images);
      if (onStatus) onStatus(`${images.length} imagen(es) extraída(s) del documento.`);
    }

    if (onImported) onImported({ markdown, title: guessTitleFromMarkdown(markdown) });
    onStatus('Importado. Revisa el contenido antes de guardar.', 'ok');
  } catch (e) {
    onStatus(e.message || 'Error al importar.', 'error');
  }
}

export { markdownToExcerpt };
